import { css } from '@emotion/react';
import { Breakpoint, spacing, zIndex } from '../../config/styles';
import { StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';

const dark = '#0D0B2A';
const pink = '#FF2D78';

const styles = {
  header: css`
    width: 100%;
    background: ${dark};
    z-index: ${zIndex.header};
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      background: rgba(255, 255, 255, 0.07);
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 48px;
      height: 2px;
      background: ${pink};
    }
  `,

  inner: css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${spacing['25']} ${spacing['40']};

    ${Breakpoint.mobile} {
      padding: ${spacing['25']} ${spacing['40']};
    }
  `,

  logoLink: css`
    display: flex;
    align-items: center;
    width: 90px;

    ${Breakpoint.mobile} {
      width: 70px;
    }

    img {
      display: block;
    }
  `,
};

const Header = () => {
  return (
    <header css={styles.header}>
      <div css={styles.inner}>
        <Link to={'/'} css={styles.logoLink}>
          <StaticImage src="../../images/logo.svg" alt="Ismegink.lt" placeholder="blurred" />
        </Link>
      </div>
    </header>
  );
};

export default Header;
